module.exports = __webpack_public_path__ + "img/box68.c06267ad.png";